import { ComponentType, ReactElement } from 'react';

import { FieldPath, FieldValues } from 'react-hook-form';

import { PatternFieldProps } from '../inputs';

export const withABNFormat = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<PatternFieldProps<any, any>>,
) => {
  return function WithABNFormat<
    TFieldValues extends FieldValues,
    TName extends FieldPath<TFieldValues>,
  >(
    props: Omit<
      PatternFieldProps<TFieldValues, TName>,
      'format' | 'valueType'
    > &
      Partial<Pick<PatternFieldProps, 'format' | 'valueType'>>,
  ): ReactElement {
    return (
      <Component
        label="ABN"
        {...props}
        format="## ### ### ###"
        valueType="value"
      />
    );
  };
};
